module.exports = __webpack_public_path__ + "static/media/cover.ed04aba0.gif";